import { ReactElement } from 'react'
import { Avatar as AntdAvatar } from 'antd'

import { PROFILE_PICTURE_PLACEHOLDER } from '@lmc/common/constants'
import styled, { css } from 'styled-components'

export type AvatarProps = {
  onClick?: () => void
  size?: number | 'large' | 'default' | 'small'
  style?: object
  url?: string
  className?: string
}

export default function Avatar({
  onClick,
  size,
  style,
  url = PROFILE_PICTURE_PLACEHOLDER,
  className,
}: AvatarProps): ReactElement {
  const avatarStyle = {
    ...(!!onClick && { cursor: 'pointer' }),
    ...style,
  }

  return (
    <AntdAvatarStyled
      role="link"
      clickable={Boolean(onClick)}
      className={className}
      onClick={onClick}
      size={size}
      src={url || PROFILE_PICTURE_PLACEHOLDER}
      style={avatarStyle}
    />
  )
}

type AntdAvatarStyledProps = { clickable: boolean; role?: 'link' }
const AntdAvatarStyled = styled(AntdAvatar).withConfig({
  shouldForwardProp: (prop) => !['clickable'].includes(prop),
})<AntdAvatarStyledProps>`
  ${(props) =>
    props.clickable &&
    css`
      cursor: pointer;
    `}
`
